import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Container, PageTitle, NbCard, Chip, NbButton } from "@/components/nb";

export default function BookmarkTake() {
  const { id } = useParams();
  const [b, setB] = useState(null);
  const [err, setErr] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get(`/study/diagnostic/bookmarks/${id}`).then((r) => setB(r.data)).catch(() => setErr("Test not found or link expired."));
  }, [id]);

  const take = () => {
    // Push into sessionStorage and jump to diagnostic which will read it
    sessionStorage.setItem("sl_take_bookmark", JSON.stringify(b));
    nav("/study/diagnostic?from=bookmark");
  };

  if (err) return <Container><NbCard color="tertiary">{err} <Link className="underline ml-2" to="/study/diagnostic">Back to diagnostics</Link></NbCard></Container>;
  if (!b) return <Container><div>Loading...</div></Container>;

  return (
    <Container>
      <PageTitle eyebrow="SHARED TEST" title={b.title} sub={`${b.questions.length} questions · shared by a peer`} />
      <NbCard color="primary" className="!p-6">
        <div className="flex items-center gap-2 mb-3">
          <Chip color="accent">{(b.difficulty || "medium").toUpperCase()}</Chip>
          <Chip color="tertiary">AI-CRAFTED</Chip>
        </div>
        <p className="text-neutral-800">You'll get 30 seconds per question, an instant score at the end, and a badge if you're fast.</p>
        <div className="mt-4 flex gap-3 flex-wrap">
          <NbButton onClick={take} color="black" data-testid="start-shared">Start test →</NbButton>
          <Link to="/study/diagnostic"><NbButton color="white">Back</NbButton></Link>
        </div>
      </NbCard>
    </Container>
  );
}
